// src/theme.js
import { createTheme } from '@mui/material/styles';
import '@fontsource/poppins'; 
const theme = createTheme({
  palette: {
    primary: {
      main: '#156AA8', 
      light: '#208EE1',
    },
    // primary: {
    //   main: '#023020', 
    //   light: '#228B22',
    // },
    secondary: {
      main: '#888585',
      light: '#EEEEEE',
    },
  },
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif', 
  },
});

export default theme;
